/**
 * Edu-Pac School Delivery - Zapiet Replacement v1.3
 *
 * KEY LOGIC:
 * - School delivery triggered ONLY when a BUNDLE product is in the cart
 * - Add-on items (scissors, rulers etc) need NO school tags
 * - Retail customers buying add-ons without a bundle = normal checkout
 * - Only bundle products need a school tag (the school name)
 *
 * TO ADD A SCHOOL: add entry to SCHOOLS below + tag the bundle product
 * TO ADD A BUNDLE: just tag it with the school name, nothing else
 *
 * v1.3 changes:
 * - syncStudentInfoToAttributes(): copies FirstName/LastName/Bundle from bundle
 *   line item properties into cart attributes keyed by BundleID. Line item
 *   properties get stripped off bundle parents at checkout; cart attributes
 *   survive as order note_attributes, so the order confirmation email can
 *   read them.
 *
 * v1.2 changes:
 * - Auto-syncs "Home Delivery Shipping Fee" product ($8/bundle) to cart
 *   when home-delivery bundles present. Adds, updates qty, or removes as needed.
 * - Includes SCHOOLFREE discount code in school checkout URL (no-op if not created)
 *
 * v1.1 changes:
 * - AJAX add-to-cart interceptor (Empire theme uses fetch, not form submit)
 * - Green banner for home delivery
 * - Sticky attribute fix: clears ep_school_key when no school bundle in cart
 * - Global checkout-button hijack catches custom "Continue to Checkout" buttons
 * - Console logs prefixed with [EduPac] for debugging
 */

(function () {
  'use strict';

  // SCHOOL DIRECTORY
  // Key = product tag on bundle (lowercase, exact match)
  var SCHOOLS = {
    "capilano elementary": {
      name: "Capilano Elementary",
      address1: "1230 W 20th St", address2: "",
      city: "North Vancouver", province: "BC", zip: "V7P 2B9", country: "Canada"
    },
    "chartwell elementary school": {
      name: "Chartwell Elementary School",
      address1: "1300 Chartwell Dr", address2: "",
      city: "West Vancouver", province: "BC", zip: "V7S 2R3", country: "Canada"
    },
    "cypress park - june delivery": {
      name: "Cypress Park",
      address1: "4355 Marine Dr", address2: "",
      city: "West Vancouver", province: "BC", zip: "V7V 1P2", country: "Canada"
    },
    "douglas elementary": {
      name: "Douglas Elementary",
      address1: "17325 2 Ave", address2: "",
      city: "Surrey", province: "BC", zip: "V3Z 9P9", country: "Canada"
    },
    "gleneagles": {
      name: "Gleneagles Elementary",
      address1: "6350 Marine Dr", address2: "",
      city: "West Vancouver", province: "BC", zip: "V7W 2S5", country: "Canada"
    },
    "gray elementary": {
      name: "Gray Elementary",
      address1: "10855 80 Ave", address2: "",
      city: "Delta", province: "BC", zip: "V4C 1W4", country: "Canada"
    },
    "hollyburn elementary": {
      name: "Hollyburn Elementary",
      address1: "1329 Duchess Ave", address2: "",
      city: "West Vancouver", province: "BC", zip: "V7T 1H5", country: "Canada"
    },
    "holy cross elementary": {
      name: "Holy Cross Elementary",
      address1: "1450 Delta Ave", address2: "",
      city: "Burnaby", province: "BC", zip: "V5B 3G2", country: "Canada"
    },
    "home quest": {
      name: "Home Quest",
      address1: "9240 112 St", address2: "",
      city: "Delta", province: "BC", zip: "V4C 4X8", country: "Canada"
    },
    "ic delta (pac's & bulk) - june delivery": {
      name: "IC Delta",
      address1: "8840 119 St", address2: "",
      city: "Delta", province: "BC", zip: "V4C 6M4", country: "Canada"
    },
    "irwin park elementary": {
      name: "Irwin Park Elementary",
      address1: "2455 Haywood Ave", address2: "",
      city: "West Vancouver", province: "BC", zip: "V7V 1Y2", country: "Canada"
    },
    "lions bay elementary": {
      name: "Lions Bay Elementary",
      address1: "250 Bayview Rd", address2: "",
      city: "Lions Bay", province: "BC", zip: "V0N 2E0", country: "Canada"
    },
    "neilson grove elementary": {
      name: "Neilson Grove Elementary",
      address1: "5500 Admiral Blvd", address2: "",
      city: "Delta", province: "BC", zip: "V4K 1S8", country: "Canada"
    },
    "our lady of good counsel school": {
      name: "Our Lady of Good Counsel School",
      address1: "10504 139 St", address2: "",
      city: "Surrey", province: "BC", zip: "V3T 4L5", country: "Canada"
    },
    "ridgeview elementary": {
      name: "Ridgeview Elementary",
      address1: "1250 Mathers Ave", address2: "",
      city: "West Vancouver", province: "BC", zip: "V7T 2E5", country: "Canada"
    },
    "southpointe academy": {
      name: "Southpointe Academy",
      address1: "1900 56 St", address2: "",
      city: "Delta", province: "BC", zip: "V4L 2B1", country: "Canada"
    },
    "st. anthony's school": {
      name: "St. Anthony's School",
      address1: "595 Keith Rd", address2: "",
      city: "West Vancouver", province: "BC", zip: "V7T 1L8", country: "Canada"
    },
    "st. augustine's school": {
      name: "St. Augustine's School",
      address1: "2154 W 7th Ave", address2: "",
      city: "Vancouver", province: "BC", zip: "V6K 0E3", country: "Canada"
    },
    "st. francis xavier": {
      name: "St. Francis Xavier",
      address1: "428 Great Northern Way", address2: "",
      city: "Vancouver", province: "BC", zip: "V5T 4S5", country: "Canada"
    },
    "west bay elementary": {
      name: "West Bay Elementary",
      address1: "3175 Thompson Pl", address2: "",
      city: "West Vancouver", province: "BC", zip: "V7V 3E3", country: "Canada"
    },
    "westcot elementary": {
      name: "Westcot Elementary",
      address1: "760 Westcot Rd", address2: "",
      city: "West Vancouver", province: "BC", zip: "V7S 1N7", country: "Canada"
    },
    "wix-brown elementary": {
      name: "Wix-Brown Elementary",
      address1: "23851 24 Ave", address2: "",
      city: "Langley Twp", province: "BC", zip: "V2Z 3A3", country: "Canada"
    },
    "york house": {
      name: "York House School",
      address1: "4176 Alexandra St", address2: "",
      city: "Vancouver", province: "BC", zip: "V6J 2B3", country: "Canada"
    }
  };

  var HOME_DELIVERY_TAG = "home-delivery";
  var ATTR_KEY  = "ep_school_key";
  var ATTR_NAME = "ep_school_name";

  // Home Delivery Shipping Fee product variant
  // Product: gid://shopify/Product/9260958613731
  var FEE_VARIANT_ID = 48935836451043;

  // State for global click handler (set when school is detected in cart)
  var currentSchool = null;
  var currentCheckoutURL = null;

  // Lock to prevent fee sync from re-entering during its own cart updates
  var feeSyncInProgress = false;

  // ── Helpers ──────────────────────────────────────────────────────────────

  function getSchoolFromTags(tags) {
    if (!tags) return null;
    var list = Array.isArray(tags)
      ? tags.map(function(t){ return t.trim().toLowerCase(); })
      : String(tags).split(',').map(function(t){ return t.trim().toLowerCase(); });
    if (list.indexOf(HOME_DELIVERY_TAG) !== -1) {
      return { key: HOME_DELIVERY_TAG, data: { type: 'home' } };
    }
    for (var i = 0; i < list.length; i++) {
      if (SCHOOLS[list[i]]) return { key: list[i], data: SCHOOLS[list[i]] };
    }
    return null;
  }

  function setAttrs(attrs, cb) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function(r){ return r.json(); }).then(function(d){ if(cb) cb(d); })
      .catch(function(e){ console.warn('[EduPac] setAttrs', e); });
  }

  function clearSchoolAttr() {
    var clear = {};
    clear[ATTR_KEY] = '';
    clear[ATTR_NAME] = '';
    setAttrs(clear);
    currentSchool = null;
    currentCheckoutURL = null;
    var banner = document.getElementById('school-delivery-banner');
    if (banner) banner.style.display = 'none';
    console.log('[EduPac] Cleared school attribute (no school bundle in cart)');
  }

  function getCart(cb) {
    fetch('/cart.js').then(function(r){ return r.json(); }).then(cb)
      .catch(function(e){ console.warn('[EduPac] cart.js', e); });
  }

  function buildCheckoutURL(s) {
    var p = [
      ['discount', 'SCHOOLFREE'],
      ['checkout[shipping_address][first_name]', ''],
      ['checkout[shipping_address][last_name]', ''],
      ['checkout[shipping_address][company]', s.name],
      ['checkout[shipping_address][address1]', s.address1],
      ['checkout[shipping_address][address2]', s.address2 || ''],
      ['checkout[shipping_address][city]', s.city],
      ['checkout[shipping_address][province]', s.province],
      ['checkout[shipping_address][zip]', s.zip],
      ['checkout[shipping_address][country]', s.country],
      ['checkout[shipping_address][phone]', '']
    ];
    return '/checkout?' + p.map(function(pair){
      return encodeURIComponent(pair[0]) + '=' + encodeURIComponent(pair[1]);
    }).join('&');
  }

  // Detects any element that looks like a "go to checkout" trigger
  function isCheckoutTrigger(el) {
    if (!el || !el.tagName) return false;

    // Anchor with checkout in href
    if (el.tagName === 'A') {
      var href = el.getAttribute('href') || '';
      if (href === '/checkout' || href.indexOf('/checkout?') === 0 || href.indexOf('/checkout/') === 0) return true;
    }

    // Standard Shopify cart submit
    if ((el.tagName === 'BUTTON' || el.tagName === 'INPUT') && el.getAttribute('name') === 'checkout') return true;

    // Common class/id selectors
    if (el.hasAttribute && el.hasAttribute('data-cart-checkout')) return true;
    if (el.id === 'CartDrawer-Checkout') return true;
    if (el.classList && (
        el.classList.contains('cart__checkout-button') ||
        el.classList.contains('atc-button--checkout')
    )) return true;

    // Text-based fallback (catches custom buttons like dekstech "Continue to Checkout")
    if (el.tagName === 'BUTTON' || el.tagName === 'A') {
      var text = (el.textContent || '').trim().toLowerCase();
      if (text === 'checkout' ||
          text === 'check out' ||
          text === 'proceed to checkout' ||
          text === 'continue to checkout' ||
          text === 'go to checkout') {
        return true;
      }
    }

    return false;
  }

  function hijackCheckout(school) {
    if (school.type === 'home') {
      currentSchool = null;
      currentCheckoutURL = null;
      console.log('[EduPac] Home delivery - skipping checkout hijack');
      return;
    }
    currentSchool = school;
    currentCheckoutURL = buildCheckoutURL(school);
    console.log('[EduPac] Hijack armed for:', school.name, '→', currentCheckoutURL);

    // Rewrite href on known anchor checkout links (helps with right-click "Open in new tab")
    var sel = [
      'a[href="/checkout"]','a[href*="/checkout"]'
    ].join(',');
    document.querySelectorAll(sel).forEach(function(el) {
      el.href = currentCheckoutURL;
    });
  }

  function showBanner(school) {
    var el = document.getElementById('school-delivery-banner');
    if (!el) {
      el = document.createElement('div');
      el.id = 'school-delivery-banner';
      var target = document.querySelector('form[action="/cart"]') ||
                   document.querySelector('.cart__items') ||
                   document.querySelector('#CartDrawer .drawer__inner');
      if (target) target.insertBefore(el, target.firstChild);
    }
    el.style.display = 'block';

    if (school.type === 'home') {
      el.innerHTML =
        '<div style="background:#f0fff4;border:1.5px solid #9ae6b4;border-radius:10px;' +
        'padding:14px 16px;margin-bottom:16px;font-size:14px;font-family:inherit">' +
          '<div style="display:flex;gap:10px;align-items:flex-start">' +
            '<svg viewBox="0 0 24 24" style="width:22px;min-width:22px;height:22px;' +
            'stroke:#276749;fill:none;stroke-width:2;margin-top:1px">' +
              '<path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>' +
              '<polyline points="9 22 9 12 15 12 15 22"/>' +
            '</svg>' +
            '<div>' +
              '<div style="font-weight:700;color:#276749;margin-bottom:4px">Home delivery</div>' +
              '<div style="color:#276749;font-size:13px;line-height:1.6">' +
                'Your order will be shipped directly to your home. A $8 home delivery fee per bundle has been added to your cart. Please enter your delivery address at checkout.' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>';
      return;
    }

    el.innerHTML =
      '<div style="background:#ebf8ff;border:1.5px solid #90cdf4;border-radius:10px;' +
      'padding:14px 16px;margin-bottom:16px;font-size:14px;font-family:inherit">' +
        '<div style="display:flex;gap:10px;align-items:flex-start">' +
          '<svg viewBox="0 0 24 24" style="width:22px;min-width:22px;height:22px;' +
          'stroke:#2b6cb0;fill:none;stroke-width:2;margin-top:1px">' +
            '<path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>' +
            '<polyline points="9 22 9 12 15 12 15 22"/>' +
          '</svg>' +
          '<div>' +
            '<div style="font-weight:700;color:#2b6cb0;margin-bottom:4px">School delivery: ' + school.name + '</div>' +
            '<div style="color:#2c5282;line-height:1.6">' +
              school.address1 + (school.address2 ? '<br>' + school.address2 : '') +
              '<br>' + school.city + ', ' + school.province + '\u00a0' + school.zip +
            '</div>' +
            '<div style="color:#718096;font-size:12px;margin-top:8px;padding-top:6px;border-top:1px solid #bee3f8">' +
              'Your order ships directly to the school. At checkout, please enter <strong>your</strong> first and last name and do not change the pre-filled address.' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  // ── Sync bundle student info to cart attributes (survives checkout) ─────
  // Line item properties on bundle parents get stripped by Shopify Bundles
  // at checkout, but cart attributes survive as order note_attributes.
  // The email template reads from both.

  function syncStudentInfoToAttributes(cart) {
    var newAttrs = {};
    (cart.items || []).forEach(function(item) {
      var props = item.properties || {};
      if (!props.BundleID) return;
      var bid = props.BundleID;
      if (props.FirstName) newAttrs['student_' + bid + '_firstName'] = String(props.FirstName);
      if (props.LastName) newAttrs['student_' + bid + '_lastName'] = String(props.LastName);
      if (props.Bundle) newAttrs['student_' + bid + '_bundle'] = String(props.Bundle);
    });
    if (Object.keys(newAttrs).length === 0) return;
    console.log('[EduPac] Syncing student info to cart attributes', newAttrs);
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: newAttrs })
    })
      .then(function(r){ return r.json(); })
      .catch(function(e){ console.warn('[EduPac] syncStudentInfo failed', e); });
  }

  // ── Global click capture (catches ANY checkout button, including custom ones) ──

  document.addEventListener('click', function(e) {
    if (!currentCheckoutURL) return;

    // Walk up DOM from click target looking for a checkout-like element
    var target = e.target;
    while (target && target !== document.body && target !== document.documentElement) {
      if (isCheckoutTrigger(target)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        console.log('[EduPac] Intercepted checkout click on:', target.tagName, target.id || target.className || target.textContent.trim().substring(0, 30));
        console.log('[EduPac] Redirecting to:', currentCheckoutURL);
        window.location.href = currentCheckoutURL;
        return;
      }
      target = target.parentElement;
    }
  }, true);

  // ── Walk cart items: find school + count home-delivery bundles + locate fee line ──

  function findSchoolInCart(cart, cb) {
    var items = cart.items || [];
    var attrs = cart.attributes || {};

    // Locate the fee line item synchronously (no fetch needed)
    var feeLine = null;
    for (var i = 0; i < items.length; i++) {
      if (items[i].variant_id === FEE_VARIANT_ID || items[i].id === FEE_VARIANT_ID) {
        feeLine = items[i];
        break;
      }
    }

    if (!items.length) {
      if (attrs[ATTR_KEY]) clearSchoolAttr();
      return cb(null, 0, null);
    }

    var found = null;
    var homeBundleQty = 0;
    var remaining = items.length;

    function done() {
      remaining--;
      if (remaining > 0) return;

      if (found) {
        if (attrs[ATTR_KEY] !== found.key) {
          var save = {};
          save[ATTR_KEY] = found.key;
          save[ATTR_NAME] = found.data.name || '';
          setAttrs(save);
        }
      } else if (attrs[ATTR_KEY]) {
        clearSchoolAttr();
      }
      cb(found, homeBundleQty, feeLine);
    }

    items.forEach(function(item) {
      // Skip the fee product — not a school bundle, no need to fetch tags
      if (item.variant_id === FEE_VARIANT_ID || item.id === FEE_VARIANT_ID) {
        done();
        return;
      }

      fetch('/products/' + item.handle + '.js')
        .then(function(r){ return r.json(); })
        .then(function(product) {
          var school = getSchoolFromTags(product.tags);
          if (school) {
            if (!found) found = school;
            if (school.key === HOME_DELIVERY_TAG) {
              homeBundleQty += item.quantity;
            }
          }
          done();
        })
        .catch(done);
    });
  }

  // ── Sync the Home Delivery Shipping Fee line to match bundle quantity ────

  function syncHomeDeliveryFee(needed, currentLine) {
    if (feeSyncInProgress) return;
    var currentQty = currentLine ? currentLine.quantity : 0;

    if (currentQty === needed) {
      return; // already in sync
    }

    feeSyncInProgress = true;
    console.log('[EduPac] Syncing home delivery fee: have ' + currentQty + ', need ' + needed);

    var url, body;
    if (needed === 0 && currentLine) {
      // Remove the fee entirely
      url = '/cart/change.js';
      body = { id: currentLine.key, quantity: 0 };
    } else if (currentLine) {
      // Update fee quantity
      url = '/cart/change.js';
      body = { id: currentLine.key, quantity: needed };
    } else {
      // Add fresh
      url = '/cart/add.js';
      body = { id: FEE_VARIANT_ID, quantity: needed };
    }

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function(r){ return r.json(); })
      .then(function(){
        console.log('[EduPac] Fee synced to qty ' + needed);
        feeSyncInProgress = false;
        // Refresh visual cart (Empire listens to these)
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      })
      .catch(function(e){
        console.warn('[EduPac] Fee sync failed', e);
        feeSyncInProgress = false;
      });
  }

  // ── Product page init ────────────────────────────────────────────────────

  function initProductPage() {
    var meta = window.ShopifyAnalytics &&
               window.ShopifyAnalytics.meta &&
               window.ShopifyAnalytics.meta.product;
    if (!meta) return;
    var school = getSchoolFromTags(meta.tags);
    if (!school) return;

    var saveSchool = function() {
      var a = {};
      a[ATTR_KEY]  = school.key;
      a[ATTR_NAME] = school.data.name || '';
      setAttrs(a, function(){
        console.log('[EduPac] Saved school attribute:', school.key);
      });
    };

    // 1. Traditional form submit
    var form = document.querySelector('form[action*="/cart/add"]');
    if (form) {
      form.addEventListener('submit', function(){
        setTimeout(saveSchool, 500);
      });
    }

    // 2. AJAX add-to-cart intercept (Empire theme uses fetch)
    var origFetch = window.fetch;
    window.fetch = function(input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var res = origFetch.apply(this, arguments);
      if (url.indexOf('/cart/add') !== -1) {
        res.then(function(){ setTimeout(saveSchool, 400); });
      }
      return res;
    };
  }

  // ── Cart page / drawer init ──────────────────────────────────────────────

  function initCart() {
    getCart(function(cart) {
      if (!cart) return;
      findSchoolInCart(cart, function(school, homeBundleQty, feeLine) {
        if (school) {
          showBanner(school.data);
          hijackCheckout(school.data);
        }
        // Sync the home delivery fee — quantity must match home bundle qty
        syncHomeDeliveryFee(homeBundleQty, feeLine);
        // Sync bundle student info to cart attributes (survives checkout)
        syncStudentInfoToAttributes(cart);
      });
    });
  }

  // ── Boot ─────────────────────────────────────────────────────────────────

  document.addEventListener('DOMContentLoaded', function() {
    initProductPage();
    initCart();
  });

  document.addEventListener('cart:refresh', initCart);
  document.addEventListener('cart:updated', initCart);
  document.addEventListener('shopify:section:load', initCart);

  // Poll for cart drawer checkout button (renders async in Empire)
  var poll = setInterval(function() {
    if (document.querySelector('#CartDrawer-Checkout, .cart__checkout-button, .atc-button--checkout')) {
      clearInterval(poll);
      initCart();
    }
  }, 300);
  setTimeout(function(){ clearInterval(poll); }, 6000);

})();
